import styled from 'styled-components';

import { colors } from '../../../styles/constants';

export const FormBuilderInputElementWrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

export const FormBuilderInputElement = styled.input`
  border-radius: 8px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  outline: none;
  width: 100%;
  box-shadow: none;
  border: 1px solid;
  height: 40px;
  font-size: 16px;
  padding-inline: 12px;

  ${({ theme }) => theme.mediaQuery.sm} {
    height: 56px;
    font-size: 18px;
    padding-inline: 18px;
  }
`;

export const FormBuilderInputElementErrorMessage = styled.div`
  margin-top: 6px;
  font-size: 14px;
  font-family: Roboto, sans-serif;
  color: ${colors.red};
`;
